import { Preferences } from "../enum/Preferences";
import { Preference } from "./Preference";

export const userPreferencesWithPossibleValues: Array<Preference> = [
    {
        name: Preferences.DEBUG, label: 'Debug', possibleValues: [{
            icon: 'bug-outline', description: '', value: 'false'
        },
        {
            icon: 'bug-outline', description: '', value: 'true'
        }]
    },
    {
        name: Preferences.STATISTICIAN, label: 'Statistician', possibleValues: [{
            icon: 'analytics-outline', description: '', value: 'false'
        },
        {
            icon: 'analytics-outline', description: '', value: 'true'
        }]
    },/*
    {
        name: Preferences.THEME, label: 'Theme', possibleValues: [{
            icon: 'contrast-outline', description: 'Dark', value: 'dark'
        },
        {
            icon: 'contrast-outline', description: 'Light', value: 'light'
        }]
    },*/
    {
        name: Preferences.LANGUAGES, label: 'Language', possibleValues: [{
            icon: 'fi fi-gb fis', description: 'English', value: 'en'
        },
        {
            icon: 'fi fi-it fis', description: 'Italiano', value: 'it'
        }]
    }, {
        name: Preferences.USERCONTROLPANEL, label: 'User Control Panel', possibleValues: [{
            icon: 'people-outline', description: '', value: 'false'
        },
        {
            icon: 'people-outline', description: '', value: 'true'
        }]
    }
]

export const centrePreferencesWithPossibleValues: Array<Preference> = [
    {
        name: Preferences.TYPEIMPORT, label: 'Import Type', possibleValues: [{
            icon: 'download-outline', description: 'With Choice', value: 'withChoice'
        },
        {
            icon: 'download-outline', description: 'Without Choice', value: 'withoutChoice'
        },
        {
            icon: 'download-outline', description: 'Automatic', value: 'automatic'
        }]
    },
    {
        name: Preferences.ASKCONSENT, label: 'Ask for consent', possibleValues: [{
            icon: 'close-outline', description: 'Dont ask', value: 'false'
        },
        {
            icon: 'checkmark-outline', description: 'Ask', value: 'true'
        }]
    },
   /* {
        name: Preferences.GCPSTRATEGY, label: 'GCP strategy', possibleValues: [{
            icon: 'download-outline', description: 'Always', value: 'always'
        },
        {
            icon: 'download-outline', description: 'When crf is changed', value: 'whenCrfIsChanged'
        },
        {
            icon: 'download-outline', description: 'Never', value: 'never'
        }]
    },*/
]